import script from "./withdrawPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./withdrawPopup.vue?vue&type=script&setup=true&lang=ts"

import "./withdrawPopup.vue?vue&type=style&index=0&id=05fdcaa0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05fdcaa0"]])

export default __exports__